import { render, staticRenderFns } from "./SoilMoistureForm.vue?vue&type=template&id=befa3bf4&"
import script from "./SoilMoistureForm.vue?vue&type=script&lang=js&"
export * from "./SoilMoistureForm.vue?vue&type=script&lang=js&"
import style0 from "./SoilMoistureForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports